import React, { useContext, useEffect } from "react";

import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";

// Settings page components
import Sidenav from "./components/SideNav";
import Header from "./components/Header";
import AccountInfo from "./components/AccountInfo";
import CompanyInfo from "./components/CompanyInfo";
import ChangePassword from "./components/ChangePassword";
import PlatformSettings from "./components/PlatformSettings";
import DeleteAccount from "./components/DeleteAccount";
import InviteDesigner from "./components/InviteDesigner";
import ProjectSetting from "./components/ProjectSetting";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

function Settings() {
  const { store, tags = [], retriveStore, updateStore } = useContext(StoreContext);
  const account = useContext(AccountContext);

  return (
    <SuiBox mt={4}>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={3}>
          <Sidenav />
        </Grid>
        <Grid item xs={12} lg={9}>
          <SuiBox mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Header />
              </Grid>
              <Grid item xs={12}>
                <AccountInfo />
              </Grid>
              {account.account_type == "ma" ? (
                <Grid item xs={12}>
                  <ProjectSetting />
                </Grid>
              ) : null}
              <Grid item xs={12}>
                <ChangePassword />
              </Grid>
              {account.account_type == "de" ? (
                <Grid item xs={12}>
                  <InviteDesigner />
                </Grid>
              ) : null}
              <Grid item xs={12}>
                <DeleteAccount />
              </Grid>
            </Grid>
          </SuiBox>
        </Grid>
      </Grid>
    </SuiBox>
  );
}

export default Settings;
